import './App.scss';
import CityProfits from './components/cityProfits/cityProfits';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from './components/home/home';
import NemesisLogo from './components/nemesisLogo/nemesisLogo';
import background from './res/backgroundlooprev.mp4';
import { useState } from 'react';
import HomeNavBar from './components/navBar/homeNavBar';
import Regear from './components/regear/Regear';
import RegearAdmin from './components/regearAdmin/regearAdmin';

function App() {
  const [homeAnimation, setHomeAnimation] = useState(true);
  return (
    <>
      <video
        autoPlay="autoplay"
        muted
        loop
        playbackrate="0.5"
        className="myVideo"
      >
        <source src={background} type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>

      <div className="App">
        <NemesisLogo />
        <Router>
          <HomeNavBar />
          <div className="componentContainer">
            <Route exact path="/">
              <Home
                homeAnimation={homeAnimation}
                setHomeAnimation={setHomeAnimation}
              />
            </Route>
            <Route exact path="/itemsearch">
              <CityProfits />
            </Route>
            <Route exact path="/regearSystem">
              <Regear />
            </Route>
            <Route exact path="/regearSystem/Admin">
              <RegearAdmin />
            </Route>
          </div>
        </Router>
      </div>
    </>
  );
}

export default App;
